import React from 'react'

function LoginFooter() {
  return (
    <>
      <footer id="footer" className="footer text-center pb-4">
        <ul className="social-menu social-menu--landing social-menu--landing-glitch">
          {/* <li>
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram" />
              <span className="link-subtitle">Instagram</span>EOG INSTAGRAM
            </a>
          </li> */}
          <li>
            <a href="https://x.com/arenai_sol/" target="_blank" rel="noreferrer">
              <i className='square-x-twitter-brands-solid' />
              <span className="link-subtitle">Twitter / X</span>@ARENAI_SOL
            </a>
          </li>
          {/* <li>
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin" />
              <span className="link-subtitle">Linkedin</span>EOG LINKEDIN
            </a>
          </li>
          <li>
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-discord" />
              <span className="link-subtitle">Discord</span>EOG DISCORD
            </a>
          </li>
          <li>
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook" />
              <span className="link-subtitle">FACEBOOK</span>EOG FACEBOOK
            </a>
          </li> */}
        </ul>
      </footer>
    </>
  )
}

export { LoginFooter }
